const location = {
	"location.state": "City"
};

export { location };